























































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {DetailPageConfig} from "@/interfaces/detail-page.interface";

@Component({
  components: {}
})

export default class FilmDescription extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  @Prop() content: any;

  @Prop() title: string;
  @Prop() director: string;
  @Prop() year: string;
  @Prop() copyright: string;
  @Prop() more_info: DetailPageConfig.IMoreInfo;

  @Prop() hide_title = false;

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }
}
